(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var uid = 0;

  function initMarquee(wrapper) {
    if (wrapper._bmInit) return;
    wrapper._bmInit = true;

    var track = wrapper.querySelector('[data-bm-track]');
    if (!track) return;

    var speed = parseFloat(wrapper.dataset.bmSpeed) || 80;
    var dir = wrapper.dataset.bmDirection === 'right' ? 1 : -1;
    var styleEl = null;
    var animName = 'bm-roll-' + (++uid);
    var originals = Array.from(track.children);
    var resizeTimer = null;

    function buildAnimation() {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;

      // Remove any prior clones — keep only the originals — so we can
      // recompute the right number for the current viewport.
      while (track.children.length > originals.length) {
        track.removeChild(track.lastChild);
      }

      var singleWidth = originals.reduce(function (sum, el) {
        return sum + el.offsetWidth;
      }, 0) + gap * originals.length;
      if (singleWidth <= 0) return;

      // Required total track width so the right edge of the viewport is
      // always covered during the animation cycle. We need at least
      //   singleWidth + viewportWidth + a safety margin.
      // Express that as a number of FULL copies of the original set.
      var viewportWidth = wrapper.offsetWidth || window.innerWidth || 1200;
      var copies = Math.ceil((viewportWidth + singleWidth) / singleWidth) + 1;
      if (copies < 2) copies = 2;

      // We already have 1 copy in the DOM (the originals). Add the rest.
      for (var c = 1; c < copies; c++) {
        originals.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('id');
          track.appendChild(clone);
        });
      }

      var shift = -singleWidth;
      var duration = (singleWidth / speed).toFixed(3);
      var animDir = dir > 0 ? 'reverse' : 'normal';

      if (styleEl) styleEl.remove();
      styleEl = document.createElement('style');
      styleEl.textContent =
        '@keyframes ' + animName + '{' +
        'from{transform:translate3d(0,0,0)}' +
        'to{transform:translate3d(' + shift + 'px,0,0)}' +
        '}';
      document.head.appendChild(styleEl);

      track.style.animationName = animName;
      track.style.animationDuration = duration + 's';
      track.style.animationTimingFunction = 'linear';
      track.style.animationIterationCount = 'infinite';
      track.style.animationDirection = animDir;
      track.style.animationPlayState = 'running';
    }

    function scheduleRebuild() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildAnimation, 150);
    }

    var imgs = Array.from(track.querySelectorAll('img'));
    var pending = imgs.filter(function (img) { return !img.complete; });

    if (pending.length === 0) {
      buildAnimation();
    } else {
      var done = 0;
      pending.forEach(function (img) {
        function onDone() { if (++done >= pending.length) buildAnimation(); }
        img.addEventListener('load', onDone, { once: true });
        img.addEventListener('error', onDone, { once: true });
      });
    }

    // Rebuild on viewport changes so the track always has enough clones
    // to cover the new viewport width.
    window.addEventListener('resize', scheduleRebuild);

    wrapper._bmDestroy = function () {
      track.style.animationName = 'none';
      if (styleEl) { styleEl.remove(); styleEl = null; }
      window.removeEventListener('resize', scheduleRebuild);
      wrapper._bmInit = false;
    };
  }

  document.querySelectorAll('[data-bm-wrapper]').forEach(initMarquee);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bm-wrapper]').forEach(initMarquee);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-bm-wrapper]').forEach(function (w) {
      if (typeof w._bmDestroy === 'function') w._bmDestroy();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-hero-warmth-check"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFhw(el) {
    var sectionId = el.dataset.sectionId;

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        el.classList.add('fhw--visible');
        observer.disconnect();
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    observer.observe(el);

    function onUnload(e) {
      if (e.detail.sectionId === sectionId) {
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', onUnload);
      }
    }

    document.addEventListener('shopify:section:unload', onUnload);
  }

  document.querySelectorAll('[data-fhw]').forEach(initFhw);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-fhw]');
    if (el) initFhw(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-hero-warmth"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFhw(el) {
    var sectionId = el.dataset.sectionId;

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        el.classList.add('fhw--visible');
        observer.disconnect();
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    observer.observe(el);

    function onUnload(e) {
      if (e.detail.sectionId === sectionId) {
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', onUnload);
      }
    }

    document.addEventListener('shopify:section:unload', onUnload);
  }

  document.querySelectorAll('[data-fhw]').forEach(initFhw);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-fhw]');
    if (el) initFhw(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      var stickyType = this.getAttribute('data-sticky-type');
      this.stickyDisabled = stickyType === 'none';
      this.headerIsAlwaysSticky = stickyType === 'always' || stickyType === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      // Skip scroll listener entirely when sticky is disabled — header stays in normal flow
      if (!this.stickyDisabled) {
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Logo swap: show inverse when transparent, default when solid
  (function() {
    function syncLogos(wrapper) {
      var transparent = wrapper.getAttribute('data-header-style') === 'transparent';
      wrapper.querySelectorAll('.header-logo--default').forEach(function(el) {
        el.style.setProperty('display', transparent ? 'none' : 'block', 'important');
      });
      wrapper.querySelectorAll('.header-logo--inverse').forEach(function(el) {
        el.style.setProperty('display', transparent ? 'block' : 'none', 'important');
      });
    }

    function initLogoSwap() {
      var wrapper = document.querySelector('.header-wrapper[data-header-style]');
      if (!wrapper) return;
      syncLogos(wrapper);
      new MutationObserver(function() { syncLogos(wrapper); })
        .observe(wrapper, { attributes: true, attributeFilter: ['data-header-style'] });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLogoSwap);
    } else {
      initLogoSwap();
    }
  })();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(sectionEl) {
      var track = sectionEl.querySelector('[data-prc-track]');
      if (!track) return;

      var wrapper = track.closest('.prc-wrapper');
      var btnPrev = wrapper && wrapper.querySelector('[data-prc-prev]');
      var btnNext = wrapper && wrapper.querySelector('[data-prc-next]');
      var dots = sectionEl.querySelectorAll('[data-prc-dot]');
      var cards = track.querySelectorAll('[data-prc-card]');

      function cardWidth() {
        var card = cards[0];
        return card ? card.offsetWidth + 20 : 320;
      }

      function activeIndex() {
        return Math.round(track.scrollLeft / cardWidth());
      }

      function updateState() {
        var idx = activeIndex();
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 4;

        if (btnPrev) btnPrev.disabled = atStart;
        if (btnNext) btnNext.disabled = atEnd;

        dots.forEach(function (dot, i) {
          dot.classList.toggle('prc-dot--active', i === idx);
        });
      }

      function scrollTo(idx) {
        track.scrollTo({ left: idx * cardWidth(), behavior: 'smooth' });
      }

      function onPrev() { scrollTo(activeIndex() - 1); }
      function onNext() { scrollTo(activeIndex() + 1); }
      function onScroll() { updateState(); }

      function onDotClick(e) {
        var dot = e.currentTarget;
        var idx = parseInt(dot.getAttribute('data-prc-dot'), 10);
        scrollTo(idx);
      }

      if (btnPrev) btnPrev.addEventListener('click', onPrev);
      if (btnNext) btnNext.addEventListener('click', onNext);
      track.addEventListener('scroll', onScroll, { passive: true });
      dots.forEach(function (dot) { dot.addEventListener('click', onDotClick); });

      updateState();

      sectionEl._prcCleanup = function () {
        if (btnPrev) btnPrev.removeEventListener('click', onPrev);
        if (btnNext) btnNext.removeEventListener('click', onNext);
        track.removeEventListener('scroll', onScroll);
        dots.forEach(function (dot) { dot.removeEventListener('click', onDotClick); });
      };
    }

    document.querySelectorAll('.shopify-section').forEach(function (el) {
      if (el.querySelector('[data-prc-track]')) initCarousel(el);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('[data-prc-track]')) initCarousel(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (typeof e.target._prcCleanup === 'function') e.target._prcCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var instances = new Map();

  function UGCSlider(root) {
    var sectionId = root.dataset.sectionId;
    var track = root.querySelector('.ugc-video-slider__track');
    var cards = Array.from(root.querySelectorAll('.ugc-video-slider__card'));
    var prevBtn = root.querySelector('.ugc-video-slider__arrow--prev');
    var nextBtn = root.querySelector('.ugc-video-slider__arrow--next');
    var autoplay = root.dataset.autoplay === 'true';

    if (!track || cards.length === 0) return;

    var currentIndex = 0;
    var autoplayTimer = null;
    var scrollTimer = null;

    function visibleCount() {
      var cardW = cards[0] ? cards[0].getBoundingClientRect().width : 0;
      var trackW = track.getBoundingClientRect().width;
      return cardW > 0 ? Math.max(1, Math.round(trackW / cardW)) : 1;
    }

    function syncUI(idx) {
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx >= cards.length - visibleCount();
    }

    function goTo(idx) {
      idx = Math.max(0, Math.min(idx, cards.length - 1));
      currentIndex = idx;
      var card = cards[idx];
      if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      syncUI(idx);
    }

    function syncFromScroll() {
      var best = 0;
      var minDist = Infinity;
      var sl = track.scrollLeft;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - track.offsetLeft - sl);
        if (dist < minDist) { minDist = dist; best = i; }
      });
      if (best !== currentIndex) { currentIndex = best; syncUI(best); }
    }

    function onScroll() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 120);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      autoplayTimer = setTimeout(function tick() {
        goTo(currentIndex + 1 >= cards.length ? 0 : currentIndex + 1);
        autoplayTimer = setTimeout(tick, 4500);
      }, 4500);
    }

    function stopAutoplay() {
      clearTimeout(autoplayTimer);
      autoplayTimer = null;
    }

    var animObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          animObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    cards.forEach(function (card) {
      animObserver.observe(card);

      var video = card.querySelector('video.ugc-video-slider__native-video');
      var playOverlay = card.querySelector('[data-play-overlay]');
      if (!video || !playOverlay) return;

      playOverlay.addEventListener('click', function () {
        stopAutoplay();
        video.play();
        playOverlay.classList.add('is-hidden');
      });

      video.addEventListener('click', function () {
        if (!video.paused) {
          video.pause();
          playOverlay.classList.remove('is-hidden');
          startAutoplay();
        }
      });

      video.addEventListener('ended', function () {
        playOverlay.classList.remove('is-hidden');
        startAutoplay();
      });
    });

    function onWheel(e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        window.scrollBy(0, e.deltaY);
      }
    }
    track.addEventListener('wheel', onWheel, { passive: false });
    track.addEventListener('scroll', onScroll);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        goTo(currentIndex - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        goTo(currentIndex + 1);
        startAutoplay();
      });
    }

    goTo(0);
    startAutoplay();

    function destroy() {
      stopAutoplay();
      clearTimeout(scrollTimer);
      animObserver.disconnect();
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('wheel', onWheel);
    }

    instances.set(sectionId, { destroy: destroy });
  }

  function initSection(container) {
    var el = container.classList && container.classList.contains('ugc-video-slider')
      ? container
      : container.querySelector && container.querySelector('.ugc-video-slider');
    if (el && !instances.has(el.dataset.sectionId)) UGCSlider(el);
  }

  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.ugc-video-slider') : null;
    if (!el) return;
    var id = el.dataset.sectionId;
    if (instances.has(id)) { instances.get(id).destroy(); instances.delete(id); }
  });

  document.querySelectorAll('.ugc-video-slider').forEach(function (el) { UGCSlider(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
